<script>
  import cardDiscountTicket from '@/components/card-discount-ticket.vue'
  export default {
    name: 'MuseumPasses',
    components: { cardDiscountTicket },
    data: () => ({
      passes: [
        {
          details: ['This pass entitles 2 adults and 2 children (Ages 5+) free admission to the museum.', 'Children 4 and under are always free.'],
          discount: '',
          expiration: '',
          homepage: 'americanairpowermuseum.com',
          logo: 'https://media.eipl.org/site/images/tickets/airpower-museum.jpg',
          price: '',
          slug: 'airpower-museum',
          title: 'American Air Power Museum',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: [
            'General admission for two adults and children 17 and under.',
            'Advance reservations are strongly encouraged but not required.',
            'All visitors, including members, must have a ticket scanned to enter the Garden.',
            'Choose "Affiliated Organization Tickets" while making your reservations.',
            'Reservations may be made up to two weeks in advance.',
            'The Pass does not include special festivals or member’s only events.'
          ],
          discount: '',
          expiration: '',
          homepage: 'https://www.bbg.org/',
          logo: 'https://media.eipl.org/site/images/tickets/bbgarden.svg',
          price: '',
          slug: 'bb-garden',
          title: 'Brooklyn Botanic Garden',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: [
            'This pass entitles 4 people free admission to the museum. At least one must be an adult.'
            // 'After requesting the Library Pass, reservations must also be made online (homepage link below)',
            // 'Patrons MUST reserve tickets for the date listed on their Library Pass.',
            // 'When making a CMEE reservation on the website, enter the Library Name in the "Notes" section of the checkout.',
            // 'Patrons should select "Library Pass-Adult" and "Library Pass-Child."'
          ],
          discount: '',
          expiration: '',
          homepage: 'https://www.cmee.org/en',
          logo: 'https://media.eipl.org/site/images/tickets/cmee.jpg',
          price: '',
          slug: 'cmee',
          title: "Children's Museum East End",
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: [
            'Admits 4 people.',
            'Pass is not valid for special events, such as Hops and Props, Tattoo Expo, Festival of the Trees, Chocolate Expo, Eternal-Con, Evening Events etc.',
            'Discount privileges available in Museum store, café, and discounts on purchase of Planetarium and additional gallery tickets.'
          ],
          discount: '',
          expiration: '',
          homepage: 'www.cradleofaviation.org',
          logo: 'https://media.eipl.org/site/images/tickets/cradle-of-aviation.png',
          price: '',
          slug: 'cradle-of-aviation',
          title: 'Cradle of Aviation',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: [
            'Pass includes free tower tour admission for 2 adults and up to 4 children.',
            'Children must be 42" to climb.',
            'Not valid for special programs and events.',
            'Park in Field #5 of the Robert Moses State Park and take the boardwalk to the lighthouse.',
            'Lighthouse tours available until 1 hour before closing.'
          ],
          discount: '',
          expiration: '',
          homepage: 'https://www.fireislandlighthouse.com/',
          // logo: 'https://media.eipl.org/site/images/tickets/fi-lighthouse.jpg',
          logo: 'https://media.eipl.org/site/images/tickets/fi-lighthouse.png',
          price: '',
          slug: 'fi-lighthouse',
          title: 'Fire Island Light House',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: [
            'This pass provides free admission for up to four adults or students, plus $5 admission for a maximum of two additional guests. ',
            'Children under 12 years of age are always free.',
            'Library members are not required to reserve tickets in advance, rather they can visit by coming to the museum with their valid library pass.'
          ],
          discount: '',
          expiration: '',
          homepage: 'https://www.guggenheim.org/  ',
          logo: 'https://media.eipl.org/site/images/tickets/guggenheim.jpg',
          price: '',
          slug: 'guggenheim',
          title: 'Guggenheim Museum',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: [
            'Library pass guests receive admission for four guests (4) to Harbes Barnyard Adventure at 715 Sound Ave, Mattituck.',
            'The library pass cannot be used at any other Harbes locations.',
            'Children 2 and under are admitted for free and would not count as part of a library pass admission.',
            'Patrons MUST have a printed copy of their library pass OR show a digital version of the pass to an admission cashier at check-in.',
            'A valid photo ID is required. The name on the ID must match the name on the reserved pass. '
          ],
          discount: '',
          expiration: '',
          homepage: 'https://harbesfamilyfarm.com/harbes-family-farm/',
          logo: 'https://media.eipl.org/site/images/tickets/harbes-farm.png',
          price: '',
          slug: 'harbes-farm',
          title: 'Harbes Family Farm',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: [
            'This printed pass in conjunction with your library card entitles free admission for 4 people (2 adults and 2 children).',
            'Access to the express, members-only admission line and discounted additional guest tickets ($18 adult, $13 child) are also included.'
          ],
          discount: '',
          expiration: '',
          homepage: 'https://intrepidmuseum.org/',
          logo: 'https://media.eipl.org/site/images/tickets/intrepid.png',
          price: '',
          slug: 'intrepid',
          title: 'Intrepid Air and Space Museum',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: ['Pass admits a family of up to 6 people: 2 adults and 4 children.'],
          discount: '',
          expiration: '',
          homepage: 'https://www.sciencecenterli.org/',
          logo: 'https://media.eipl.org/site/images/tickets/lisc.jpg',
          price: '',
          slug: 'lisc',
          title: 'L.I. Science Center',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: [
            'This pass entitles admission for 2 adults and up to six accompanying children, free parking, and a discount in the gift store. ',
            'Any additional persons accompanying them will need to purchase tickets in advance from their website.',
            'Library pass holders do not need to make a reservation to visit. Just provide the printed pass to the admissions booth staff.',
            'Library pass holders MUST arrive by 5:00 p.m. Arrivals after that time will not be permitted entry.'
          ],
          discount: '',
          expiration: '',
          homepage: 'https://www.oldwestburygardens.org/',
          logo: 'https://media.eipl.org/site/images/tickets/old-westbury-gardens.png',
          price: '',
          slug: 'old-westbury-gardens',
          title: 'Old Westbury Gardens',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: [
            'This pass includes entry for two adults and two children per tour day to take a guided tour through the Manor during their regular tour season.',
            'Tours are scheduled every hour per tour day beginning at 11 am.',
            'Not valid for the Fall Festival or Christmas House Tours.',
            'See home page for current tours schedule.'
          ],
          discount: '',
          expiration: '',
          homepage: 'https://sagtikosmanor.org/',
          logo: 'https://media.eipl.org/site/images/tickets/sagtikos-manor.jpg',
          price: '',
          slug: 'sagtikos-manor',
          title: 'Sagtikos Manor',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        },
        {
          details: [
            'Family Pass admits 2 adults and up to 4 children under 18 to the Estate grounds and Museum exhibits.',
            'Mansion tours and Planetarium shows are not included.',
            'Call to confirm seasonal and holiday hours.',
            'The Vanderbilt Estate has cobblestone roads and hilly terrain. Please wear sensible shoes.'
          ],
          discount: '',
          expiration: '',
          homepage: 'https://www.vanderbiltmuseum.org/',
          logo: 'https://media.eipl.org/site/images/tickets/vanderbilt.png',
          price: '',
          slug: 'vanderbilt',
          title: 'Vanderbilt',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        }
        // {
        //   details: [],
        //   discount: '',
        //   expiration: '',
        //   homepage: '',
        //   logo: 'https://media.eipl.org/site/images/tickets/',
        //   price: '',
        //   slug: '',
        //   title: '',
        //   ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        // },
      ],
      pickupPasses: [
        {
          details: [
            'The pass provides free entry of one vehicle.',
            'The Empire Pass does not guarantee free vehicle entry into the park when special events occur and are operated by other organizations.',
            'The Empire Pass does not included waiver of fees for camping, golf, museum or historic site admission and other special activity fees are not included.',
            'Please check the homepage to confirm days/hours of operation before reserving passes.'
          ],
          discount: '',
          expiration: '',
          homepage: 'https://parks.ny.gov/',
          logo: 'https://media.eipl.org/site/images/tickets/empire-pass.jpg',
          price: '',
          slug: 'empire-pass',
          title: 'Empire Pass',
          ticket_url: 'https://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes'
        }
        // {
        //   details: [],
        //   discount: '',
        //   expiration: '',
        //   homepage: '',
        //   logo: 'https://media.eipl.org/site/images/tickets/',
        //   price: '',
        //   slug: '',
        //   title: '',
        //   ticket_url: ''
        // },
      ]
    }),
    computed: {},
    methods: {},
    created() {}
  }
</script>

<template>
  <v-container class="d-flex flex-column align-center mb-8 rounded-lg">
    <h1 class="text-h2 text-center primary--text font-weight-bold mb-16">Museum Passes</h1>

    <v-card max-width="850" width="100%" class="mt-16">
      <img height="160px" width="280px" src="https://media.eipl.org/site/images/tickets/museum-pass-trans.png" class="d-block my-4 mx-auto" />

      <v-card-text class="primary--text">
        <p class="text-body-1 primary--text font-weight-bold mb-8">
          The Library provides free passes to a variety of museums. All passes may be reserved up to 30 days in advance by East Islip Library cardholders ages 18 and over that hold
          an unexpired, unblocked card with fines under $10. The passes allow free admission to some of the New York area's most popular attractions.
        </p>
        <p class="text-body-1 primary--text mb-8">Reservations may be made online by following the link below or in person at the Children's Reference Desk.</p>
        <p class="text-body-1 primary--text text--lighten-2 font-weight-bold">Please remember to check with the museum prior to your visit for days and hours of operation.</p>
      </v-card-text>
      <v-card-actions class="d-flex flex-wrap align-end justify-space-between primary--text text-center pa-4">
        <!-- <v-btn color="primary" href="http://www.eventkeeper.com/mars/tkflex.cfm?curOrg=EIPL&curapp=passes" target="_blank" class="mb-4">
          <v-icon left>mdi-bank</v-icon>RESERVE PASSES</v-btn
        > -->
        <v-btn color="primary" href="https://www2.museumkey.com/ui/?code=eastny11730" x-large target="_blank" class="mb-4 px-8">
          <v-icon left>mdi-bank</v-icon>VIEW ALL PASSES</v-btn
        >
        <v-sheet class="d-flex flex-column align-start justify-start mb-4">
          <p class="primary--text text-center mb-0">Also available</p>
          <v-btn color="primary" outlined to="/services/discount-tickets"> <v-icon left>mdi-ticket</v-icon>DISCOUNT TICKETS</v-btn>
        </v-sheet>
      </v-card-actions>
    </v-card>

    <!-- <v-sheet color="transparent" class="my-8"></v-sheet>
    <v-card max-width="850" width="100%" class="mt-8">
      <v-card-title class="primary secondary--text text-h5 font-weight-bold">PRINT AND GO</v-card-title>
      <v-card-text class="primary--text">
        <ul class="text-body-2 primary-text py-4">
          <li>These museum passes may be reserved online or in person at the Children’s Reference Desk up to 30 days in advance.</li>
          <li>These passes are good for a 1 day visit to the museum, so request your pass for the date you wish to use it.</li>
          <li>They do not need to be picked up or returned to the library.</li>
          <li>A printed pass or digital version is required for admittance to the museum. Please click on each museum to familiarize yourself with their requirements.</li>
        </ul>
      </v-card-text>
    </v-card>
    <v-sheet color="transparent" class="my-1"></v-sheet>
    <card-discount-ticket v-for="pass in passes" :key="pass.slug" :isPass="true" :ticket="pass" />
    <v-card max-width="850" width="100%" class="mt-8">
      <v-card-title class="primary secondary--text text-h5 font-weight-bold">PICK UP AND RETURN</v-card-title>
      <v-card-text class="primary--text">
        <ul class="primary-text py-4">
          <li>These museum passes may be reserved online or in person at the Children’s Reference Desk up to 30 days in advance.</li>
          <li>
            The pass may be borrowed for 3 days (first day of reservation is when pass is ready for pick up) and must be returned before closing on the third date. Please reserve a
            pass for the date you will pick it up from the Library.
          </li>
          <li>Be sure to bring your East Islip Library card to pick up your museum pass.</li>
          <li>A $20 per day fee is charged if a pass is not returned by closing time of the due date. The non-refundable fee for a lost pass is $50.</li>
          <li>This pass MUST be returned to the Children’s Reference Desk.</li>
          <li>
            By checking out a Pickup/Return museum pass, you acknowledge awareness of all of the procedures associated with the passes, and of the fines and charges associated with
            late or lost passes.
          </li>
        </ul>
      </v-card-text>
    </v-card>
    <v-sheet color="transparent" class="my-1"></v-sheet>
    <card-discount-ticket v-for="pass in pickupPasses" :key="pass.slug" :isPass="true" :ticket="pass" />
   -->
    <v-sheet color="transparent" class="my-16"></v-sheet>
    <v-sheet color="transparent" class="my-16"></v-sheet>
    <v-sheet color="transparent" class="my-16"></v-sheet>
  </v-container>
</template>

<style scoped></style>
